import React from 'react';

function TextSection({ title, children }) {
  if (!children) return null;
  return (
    <section className="answer-section">
      <h3>{title}</h3>
      <p>{children}</p>
    </section>
  );
}

function ListSection({ title, items }) {
  if (!items?.length) return null;
  return (
    <section className="answer-section answer-section--wide">
      <h3>{title}</h3>
      <ul>
        {items.map((item) => <li key={item}>{item}</li>)}
      </ul>
    </section>
  );
}

function PortfolioAnswer({ presentation, answerId }) {
  const headingId = `${answerId}-title`;
  return (
    <article className="portfolio-answer" aria-labelledby={headingId}>
      <header className="portfolio-answer__header">
        <div>
          <p className="eyebrow">Featured project</p>
          <h2 id={headingId}>{presentation.title}</h2>
        </div>
        <span className="maturity-tag">{presentation.status}</span>
      </header>
      <p className="portfolio-answer__summary">{presentation.summary}</p>

      <div className="answer-highlights" aria-label="Project highlights">
        <div>
          <span>What I've built</span>
          <strong>{presentation.implementedLabel}</strong>
        </div>
        <div>
          <span>What I focused on</span>
          <strong>{presentation.focusLabel}</strong>
        </div>
      </div>

      <div className="answer-grid">
        <TextSection title="Project scope">{presentation.scope}</TextSection>
        <TextSection title="How it fits together">{presentation.boundaries}</TextSection>
        <ListSection
          title="Key decisions"
          items={presentation.decisions}
        />
        <ListSection
          title="What's implemented"
          items={presentation.evidence}
        />
        <TextSection title="How I test it">
          {presentation.verification}
        </TextSection>
      </div>

      <div className="answer-stack" aria-label="Technology stack">
        {presentation.stack.map((tool) => <span key={tool}>{tool}</span>)}
      </div>
    </article>
  );
}

export default PortfolioAnswer;
